import { theme } from 'lib/theme';
import React from 'react';
import { View } from 'react-native';
import { Icon, ICONS } from './Icon';

export const TxtAsterisk: React.FC = () => {
  return (
    <View
      style={{
        width: 13,
        height: 13,
        top: -3,
      }}
    >
      <Icon source={ICONS.AsteriskSolid} size={9} color={theme.colors.red} />
    </View>
  );
};
